import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editInvestmentProjectRequest: ['response'],
    editInvestmentProjectSuccess: ['loading', 'response'],
    editInvestmentProjectFailure: ['error'],
})

export const editInvestmentProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const editInvestmentProjectRequest = state => state.merge({ success: null })

const editInvestmentProjectSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editInvestmentProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_INVESTMENT_PROJECT_REQUEST]: editInvestmentProjectRequest,
    [Types.EDIT_INVESTMENT_PROJECT_SUCCESS]: editInvestmentProjectSuccess,
    [Types.EDIT_INVESTMENT_PROJECT_FAILURE]: editInvestmentProjectFailure,
})
